import React from 'react'
import TwoColumnCards from '../../../react4xp/components/TwoColumnCards'

function TwoColumnCardsPart({ cards }) {
  return (
    <TwoColumnCards
      card={cards?.map(card => ({
        backgroundColor: card.backgroundColor,
        tagline: card.tagline,
        title: card.title,
        text: `<p>${card.text}</p>`,
        ctas: card.ctas
      }))}
    />
  )
}

export default (props) => <TwoColumnCardsPart {...props} />
